import { createStore, applyMiddleware, compose } from 'redux';
import {thunk} from 'redux-thunk';
import rootReducer from "./reducers/root.reducers.js";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore(initialState) {
  const composeEnhancers = (process.env.NODE_ENV === 'development') ? (
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      }) : compose) : compose;

  const enhancer = composeEnhancers(
    applyMiddleware(thunk),
  );

  const store = createStore(
    persistedReducer,
    initialState,
    enhancer,
  );

  const persistor = persistStore(store);

  return { store, persistor };
}